/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBroomLocation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7 11.083a6.032 6.032 0 0 0-3.236 1.641A5.864 5.864 0 0 0 2 16.91V22h12v-5.09a5.864 5.864 0 0 0-1.764-4.186A6.032 6.032 0 0 0 9 11.083V2H7zM17 4c-1.761 0-3 1.258-3 2.59 0 .45.132.873.373 1.248 0 0 .014.02.056.069.048.058.112.13.201.232.175.198.415.471.716.838.432.528.984 1.244 1.654 2.217a33.056 33.056 0 0 1 1.654-2.217c.3-.367.541-.64.716-.838.089-.102.153-.174.201-.232.042-.05.056-.069.056-.069A2.29 2.29 0 0 0 20 6.59C20 5.259 18.761 4 17 4zm-5 2.59C12 3.956 14.343 2 17 2s5 1.956 5 4.59c0 .857-.256 1.656-.695 2.337-.099.153-.26.336-.396.49l-.038.043c-.171.195-.392.446-.67.784-.552.675-1.339 1.71-2.36 3.297L17 14.848l-.841-1.307c-1.021-1.587-1.808-2.622-2.36-3.297-.278-.338-.499-.59-.67-.784l-.038-.044a4.592 4.592 0 0 1-.396-.489A4.293 4.293 0 0 1 12 6.59zM8 13c1.067 0 2.086.416 2.835 1.151A3.864 3.864 0 0 1 12 16.91V20h-1.5v-4h-2v4h-1v-4h-2v4H4v-3.09c0-1.032.417-2.024 1.165-2.759A4.047 4.047 0 0 1 8 13z" />
        <path d="M18 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgBroomLocation as BroomLocation };
